module.exports = __webpack_public_path__ + "img/topical_cream.5a38c62b.png";